import {
    fetchContact,
    fetchEditableContact,
} from 'flow/actions/contact-actions';
import {
    fetchExtension,
    fetchPresenceNotifications,
} from 'flow/actions/extension-actions';
import { fetchProfiles } from 'flow/actions/profile-actions';
import ContactContainers from 'flow/components/contact-card/ContactContainers';
import {
    selectExtensionContactKey,
    selectExtensionIsAiCoworker,
} from 'flow/selectors/ExtensionSelectors';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { routes } from 'flow/types/routes';

import { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';
import { generatePath, Redirect, useParams } from 'react-router-dom';

const ContactPage = () => {
    const dispatch = useAppDispatch();

    const { entityKey: extensionKey } = useParams<{
        entityKey: ExtensionKey;
    }>();

    const contactKey = useAppSelector((state) =>
        selectExtensionContactKey(state, extensionKey),
    );

    const extensionIsAiCoworker = useAppSelector((state) =>
        selectExtensionIsAiCoworker(state, extensionKey),
    );

    useEffect(() => {
        dispatch(fetchExtension(extensionKey, 'live', 'contact'));
        dispatch(fetchContact(contactKey));
        dispatch(fetchEditableContact(contactKey));
        dispatch(fetchPresenceNotifications(extensionKey, ''));
        dispatch(fetchProfiles(extensionKey));
    }, [dispatch, contactKey, extensionKey]);

    if (extensionIsAiCoworker) {
        return (
            <Redirect
                to={generatePath(routes['ai-coworker.entityKey.contact'], {
                    extensionKey,
                })}
            />
        );
    }

    return (
        <ContactContainers
            parentContactKey={contactKey}
            parentExtensionKey={extensionKey}
        />
    );
};

export default ContactPage;
